import { InitialDataAPIModel, UpdatePhoneResponseDTOAPIModel } from '@/generated/api/fps/api';
import { PhoneAPIModel } from '@/generated/api/fps/core';

export const NAMESPACE = 'AUTH';

export interface State {
  initialized: boolean;
  success: boolean;
  expired: boolean;
  loggedOut: boolean;
  forbidden: boolean;
  isNewUser: boolean;
  token?: string;
  initialData?: InitialData;
}

export type ConfirmationData = UpdatePhoneResponseDTOAPIModel;

export interface InitialData extends Omit<InitialDataAPIModel, 'phone'> {
  phone?: PhoneAPIModel;
}

export const initialState: State = {
  initialized: false,
  success: false,
  expired: false,
  forbidden: false,
  loggedOut: false,
  isNewUser: false,
};
